import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData } from "./employeeSlice";

const useBankInformation = () => {
  const dispatch = useDispatch();

  const { bankInformation } = useSelector((state) => state.employeeregister);

  const onChangeBankInformation = (name, value) => {
    dispatch(
      setEmployeeData({
        key: "bankInformation",
        value: { ...bankInformation, [name]: value },
      }),
    );
  };

  return {
    onChangeBankInformation,
    bankInformation,
  };
};

export default useBankInformation;
